<app-card [title]="title" titleSize="large" height="initial">
    <ng-template #content>
        <div class="grid-6col input-grid-gaps">
            <div class="grid-2col input-grid-gaps fr-3">
                <app-select-input
                    [form]="form"
                    id="usage"
                    label="service.patterns.structure.add.usage"
                    [staticOptions]="servicePatternTypes()"
                ></app-select-input>
                <app-text-input [form]="form" id="name" label="service.patterns.structure.fields.name"></app-text-input>
            </div>
            @if (this.service()?.type == ServiceTypeEnum.HEALTH_CARE) {
                <app-select-input
                    [form]="form"
                    [infiniteScroll]="proceduresScroll()"
                    id="procedureCode"
                    valueKey="code"
                    labelKey="code"
                    idField="code"
                    label="service.patterns.structure.add.procedure"
                    filterBy="code,name"
                    itemsPanelCssClass="proceduresItemsPanelClass"
                >
                    <ng-template #item let-item>
                        {{ item | formatServiceProcedure }}
                    </ng-template>
                    <ng-template #selectedItem let-item>
                        <app-performed-procedures
                            [procedures]="item | transformSingleServiceProcedure"
                        ></app-performed-procedures>
                    </ng-template>
                </app-select-input>
            }
            <app-date-input [form]="form" id="validFrom"></app-date-input>
            <app-date-input [form]="form" id="validTo"></app-date-input>
            <div class="fr-6">
                <app-text-input [form]="form" id="note"></app-text-input>
            </div>
            <div class="fr-6">
                <div class="flex justify-content-between align-items-center">
                    <p>{{ 'service.patterns.structure.add.structureTitle' | translate }}</p>
                    <div class="flex align-items-center gap-2">
                        @if (rawMode()) {
                            @if (hasHandlebarsBlocks()) {
                                <app-warn-float-message>
                                    <span>{{ 'wysiwyg.rawMode.handlebarsWarn' | translate }}</span>
                                </app-warn-float-message>
                            }
                            <app-button
                                label="wysiwyg.rawMode.back"
                                (clickEvent)="rawMode.set(false)"
                            ></app-button>
                        } @else {
                            <app-button
                                label="wysiwyg.rawMode.enable"
                                severity="secondary"
                                (clickEvent)="rawMode.set(true)"
                            ></app-button>
                        }
                    </div>
                </div>
                <app-input-wysiwyg
                    [form]="form"
                    id="content"
                    [autocompleteOrganization]="true"
                    editorKey="ServicesPatternsStructureContent"
                    [patternGroups]="patternGroups()"
                    [rawMode]="rawMode()"
                ></app-input-wysiwyg>
                @if (form.value.usage !== ServicePatternStructureUsageEnum.OPERATIONAL_REPORT) {
                    <app-wysiwyg-placeholder-info
                        [groups]="patternGroups()"
                        [expanded]="true"
                        [showHandleBarInfo]="false"
                    ></app-wysiwyg-placeholder-info>
                }
            </div>
        </div>
    </ng-template>

    <ng-template #footer>
        <app-action-buttons [primaryButtonVisibility]="form.enabled" (primaryClickEvent)="submit()"
            secondaryButtonType="return"></app-action-buttons>
    </ng-template>
</app-card>
